module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bbssection-card-section"
  }, [_c('div', {
    staticClass: "bbssection"
  }, [_c('div', {
    staticClass: "bbssection-content"
  }, [(_vm.section.dir) ? _c('div', {
    staticClass: "columns is-mobile is-gapless",
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "circle",
    class: _vm.sectionColor(_vm.section.id)
  }, [_c('span', [_vm._v(_vm._s(_vm.section.first_level ? _vm.section.name[0] : _vm.section.name[0]))])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-9"
  }, [_c('div', {
    staticClass: "pull-left section-name section-name-right"
  }, [(!_vm.section.first_level) ? _c('div', [_vm._v("子分区-" + _vm._s(_vm.section.name))]) : _c('div', [_vm._v(_vm._s(_vm.section.name))]), _vm._v(" "), _c('p', {
    staticClass: "title is-6"
  }, [_vm._v(_vm._s(_vm.section.desc))])])]), _vm._v(" "), (!_vm.section.dir) ? _c('div', {
    staticClass: "column is-1 icon-wrapper"
  }, [_c('i', {
    staticClass: "iconfont icon-favorite",
    class: _vm.section.fav ? 'icon-favoritesfilling' : 'icon-favorite'
  })]) : _vm._e()]) : _c('div', {
    staticClass: "columns is-mobile is-gapless",
    staticStyle: {
      "margin-left": "0.5rem"
    }
  }, [_c('div', {
    staticClass: "column is-10",
    on: {
      "click": function($event) {
        _vm.$router.push('/board/' + _vm.section.desc)
      }
    }
  }, [_c('p', {
    staticClass: "title is-6 board-name"
  }, [_vm._v(_vm._s(_vm.section.name))]), _vm._v(" "), _c('p', {
    staticClass: "title is-6"
  }, [_vm._v(_vm._s(_vm.section.desc))])]), _vm._v(" "), (!_vm.section.dir) ? _c('div', {
    staticClass: "column is-2 icon-wrapper"
  }, [_c('i', {
    staticClass: "iconfont icon-favorite",
    class: _vm.section.fav ? 'icon-favoritesfilling' : 'icon-favorite',
    on: {
      "click": function($event) {
        _vm.opFav(_vm.section)
      }
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "children-section"
  }, _vm._l((_vm.section.children), function(child, i) {
    return (_vm.isOpen) ? _c('div', {
      key: child.name,
      staticClass: "children"
    }, [_c('hr'), _vm._v(" "), _c('section-card', {
      attrs: {
        "section": child
      }
    })], 1) : _vm._e()
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21d390e6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SectionCard.vue
// module id = 237
// module chunks = 1